import {useEffect, useMemo, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import Table from '../../../common/table/TableFunctional';
import {hideLoader, showLoader} from '../../../store/common/slice';

export default function OneTimeData({filters, apartmentNumber, data, buildingID}) {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const [loadingStarted, setLoadingStarted] = useState(false);

    useEffect(() => {
        if (!loadingStarted && !data.rows) {
            dispatch(showLoader());
            setLoadingStarted(true);
        }
        if (loadingStarted && data.rows) {
            dispatch(hideLoader());
            setLoadingStarted(false);
        }
    }, [data]);

    const checkOneTimeData = () => {
        return data.rows?.some(row => Object.keys(row).some(key => key.match(/one_time_/g)));
    }

    const columnsOneTime = useMemo(
        () => {
            const stableDataColumns = [
                {
                    accessor: 'title',
                },
                {
                    Header: t('reports.tenantName'),
                    accessor: 'tenantName',
                    Cell: ({ value }) => {
                        // todo duplicate code. unify
                        value = value.map(r => `${r.tenantName} ${r.tenantType === 'unknown' ? '' : `(${t(`reports.tenantType.${r.tenantType}`)})`}`).join(', ');
                        return <>{value}</>
                    }
                }
            ];

            const oneTimeColumns = data?.headerExtras && data?.headerExtras.map(header => {
                if (!header.id) return false;
                return {
                    id: header.id,
                    Header: header.name,
                    accessor: (row) => row[`one_time_${header.id}`] && row[`one_time_${header.id}`][row.key].value,
                }
            }).filter(header => {return header.id});

            return stableDataColumns.concat(oneTimeColumns);
        },
        [data]
    );

    if (!checkOneTimeData()) return (
        <h2 className="text-center">
            {t('reports.empty_table_for', {name: t('reports.apartment.oneTime')})}
        </h2>
    )

    return data.rows && data.rows.length > 0 ? (
        <>
            <Table
                buildingId={buildingID}
                className={'new-report one-time'}
                columns={columnsOneTime}
                data={data.rows}
                filters={filters}
                tableTitle={t('reports.apartment_cashflow_title', {apartmentNumber})}
                disableSort
            />
        </>
    ) : (<h2 className='text-center'>{t('reports.empty_table')}</h2>);
}
